import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { FiltroActividades } from 'src/app/shared/models/filtroActividades';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AsignacionesService {
  headers = new HttpHeaders({
    // 'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('ET_EMYRtokenApi')}`
  });
  headersBack = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('ET_EMYRtoken')}`
  });
  constructor(private http: HttpClient) { }
  filtrar(filtros: any) {
    const params = new URLSearchParams();

    if (filtros.NPerPage) {
      params.append('nPerPage', filtros.NPerPage.toString());
    }
    if (filtros.pageNumber) {
      params.append('pageNumber', filtros.pageNumber.toString());
    }
    if (filtros.orderBy && Object.keys(filtros.orderBy).length > 0) {
      const ordenados = Object.entries(filtros.orderBy as Record<string, any>)
        .sort(([, a], [, b]) => a.order - b.order);

      ordenados.forEach(([key, obj]) => {
        if (obj.apply) {
          params.append(`orderBy[${obj.label}]`, obj.value?.toString() ?? '');
        }
      });
    }
    if (filtros.state && filtros.state.length > 0) {
      filtros.state.forEach(s => {
        params.append('state', s);
      });
    }
    if (filtros.username) {
      params.append('username', filtros.username?.trim());
    }
    if (filtros.startDate) {
      let startDate = new Date(`${filtros.startDate}T00:00:00Z`);
      startDate.setUTCHours(startDate.getUTCHours() + 3);
      params.append('startDate', startDate.getTime().toString());

    }

    if (filtros.endDate) {
      let endDate = new Date(`${filtros.endDate}T00:00:00Z`);
      endDate.setUTCHours(endDate.getUTCHours() + 3);
      params.append('endDate', endDate.getTime().toString());

    }
 
    if (filtros.description) {
      params.append('description', filtros.description?.trim());
    }
    if (filtros.assignedTo) {
      params.append('assignedTo', filtros.assignedTo);
    }
    if (filtros.ot) {
      params.append('OT', filtros.ot?.trim());
    }
    if (filtros.frencuency) {
      params.append('Frecuencia', filtros.frencuency?.trim());
    }
    if (filtros.sections) {
      params.append('Seccion', filtros.sections.trim());
    }

    if (filtros.sectionsCods && filtros.sectionsCods.length > 0) {
      filtros.sectionsCods.forEach(element => {
        if (element) {
          params.append('CodigoSeccion', element?.trim());
        }
      });
    }

    if (filtros.codigoEstacion) {
      params.append('CodigoEstacion', filtros.codigoEstacion);
    }
    if (filtros.nombre) {
      params.append('DescriEstacion', filtros.nombre);
    }

    params.append('Protocolo', 'EMyR_Mensual');

    params.append('token', localStorage.getItem('ET_EMYRtoken'));

    return this.http.get(`${environment.apiUrl}/api/assignments/filter?${params.toString()} `).pipe(
      map((isAlive: any) => {
        return isAlive;
      })
    );
  }


  users(array: any[]) {
    const params = new URLSearchParams();
    params.append('token', localStorage.getItem('ET_EMYRtoken') || '');
  
    const filters: any[] = [];
  
    // Agregamos filtro $in solo si no incluye "*"
    if (!array.includes("*")) {
      filters.push({ "categories": { "$in": array } });
    }
  
    // Este filtro siempre se aplica
    filters.push({ "categories": { "$all": ["EMyR"] } });
  
    const query = { "$and": filters };
    const encodedQuery = encodeURIComponent(JSON.stringify(query));
  
    return this.http.get(`${environment.apiUrl}/api/user?q=${encodedQuery}&${params}`).pipe(
      map((res: any) => res)
    );
  }


  asignar(assignments: any[], user?: string, userCategories?: any[]) {
    let datos: { assigments: any[]; user?: any; userCategories?: any[] } = {
      assigments: assignments
    };
    if (user) {
      datos.user = user.trim();
    }
    if (userCategories) {
      datos.userCategories = userCategories;
    }

    return this.http.post(`${environment.apiUrl}/api/assignments/assignTo?token=${localStorage.getItem('ET_EMYRtoken')}`, datos).pipe(
      map((isAlive: any) => {
        return isAlive;
      }),
      catchError((error: HttpErrorResponse) => {
        //console.error('Error en asignar:',  error);
        let errorMessage = 'Error desconocido';
        if (error.error) {
          errorMessage = typeof error.error === 'string' ? error.error : (error.error.message || JSON.stringify(error.error));
        } else if (error.message) {
          errorMessage = error.message;
        }
        return throwError(() => new Error(errorMessage));
      })
    );
  }

  desasignar(assignment: string) {
    let datos = {
      assigment: `${assignment}`
    };

    return this.http.post(`${environment.apiUrl}/api/assignments/dismissAssigment`, datos).pipe(
      map((isAlive: any) => {
        return isAlive;
      })
    );
  }

  getAllResults(pageNumber: any, pageSize: any, filtros: FiltroActividades) {
    return this.http.post(`${environment.urlBack}/allResults?pageNumber=${pageNumber}&pageSize=${pageSize} `, filtros, { headers: this.headers }).pipe(
      map((isAlive: any) => {
        return isAlive;
      })
    );
  }

}
